function Hero() {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-sm flex flex-col md:flex-row items-center pt-10 pb-12 px-6 sm:px-12 mb-12">
      <div className="md:w-1/2 md:pr-12 text-left z-20">
        <div className="inline-block px-3 py-1 mb-4 border border-gray-300 text-[10px] font-bold tracking-wider uppercase text-gray-500 rounded-full">
          New Arrivals
        </div>
        <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-5 tracking-tight leading-tight">
          Tools for the modern workspace.
        </h1>
        <p className="text-base text-gray-600 mb-8 font-normal max-w-md leading-relaxed">
          Upgrade your daily grind. We've sourced the best tech and accessories so you don't have to.
        </p>
        <button className="bg-black text-white hover:bg-gray-800 px-6 py-2.5 rounded-sm text-sm font-medium transition-colors">
          Browse Collection
        </button>
      </div>
      <div className="md:w-1/2 mt-10 md:mt-0 relative flex justify-center">
        <div className="absolute inset-0 bg-gray-200 aspect-square rounded-full blur-3xl opacity-40 translate-x-12 translate-y-8"></div>
        <img
          src="https://images.unsplash.com/photo-1593642632823-8f785ba67e45?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
          alt="Workspace setup"
          className="relative z-10 w-full max-w-sm object-cover rounded-sm shadow-xl -rotate-2 hover:rotate-0 transition-transform duration-500 border border-white"
        />
      </div>
    </div>
  );
}

export default Hero;
